export default {
  'questionModal.title': '订单咨询',
  'questionModal.orderInfo': '订单信息',
  'questionModal.productInfo': '商品信息',
  'questionModal.messages': '消息',
  'questionModal.sendMessage': '发送消息',
  'questionModal.messageSent': '消息发送成功。',
  'questionModal.messageFailed': '消息发送失败。',
  'questionModal.pleaseEnterMessage': '请输入消息。',
  'questionModal.incompleteOrderInfo': '订单信息不完整。需要订单ID和用户ID。',
  'questionModal.loadingInquiry': '正在加载咨询...',
  'questionModal.failedToLoadInquiry': '无法加载咨询。',
  'questionModal.noInquiryFound': '未找到咨询。',
  'questionModal.admin': '管理员',
  'questionModal.user': '用户',
  'questionModal.invalidTime': 'Invalid Time',
  'questionModal.orderColumns.applicationType': '申请类型',
  'questionModal.orderColumns.willShip': '出库状态',
  'questionModal.orderColumns.deliveryCenter': '配送中心/运输方式',
  'questionModal.orderColumns.receiver': '收件人',
  'questionModal.orderColumns.tracking': '跟踪数/入库数',
  'questionModal.orderColumns.rackNo': '货架号',
  'questionModal.orderColumns.status': '入库状态/进度状态',
  'questionModal.orderColumns.date': '日期',
  'questionModal.productColumns.no': '编号',
  'questionModal.productColumns.image': '图片',
  'questionModal.productColumns.name': '商品名称',
  'questionModal.productColumns.code': '代码',
  'questionModal.productColumns.trackingNo': '跟踪号',
  'questionModal.productColumns.orderNo': '订单号',
  'questionModal.productColumns.color': '颜色',
  'questionModal.productColumns.size': '尺寸',
  'questionModal.productColumns.quantity': '数量',
  'questionModal.productColumns.price': '价格',
  'questionModal.productColumns.rackNo': '货架号',
  'questionModal.productColumns.warehouseDate': '入库状态',
  'questionModal.close': '关闭',
  'questionModal.send': '发送',
  'questionModal.attachImage': '添加图片',
  'questionModal.attachFile': '添加文件',
  'questionModal.filesAdded': '已添加 {count} 个文件，将随消息一起发送。',
  'questionModal.preview': '预览',
  'questionModal.loading': '加载中...',
  'questionModal.editor': '编辑器',
  'questionModal.text': '文本',
  'questionModal.enterText': '请输入文本',
  'questionModal.inquiryCreatedAndMessageSent': '咨询已创建，消息已发送。',
  'questionModal.inquiryId': '咨询ID',
  'questionModal.userIdNotFound': '在订单中找不到用户ID。',
  'questionModal.inquiryIdNotFound': '找不到咨询ID。',
  'questionModal.failedToLoadInquiryList': '无法加载咨询列表。',
  'questionModal.failedToCreateInquiry': '创建咨询失败。',
  'questionModal.invalidOrderIdFormat': '订单ID格式不正确。',
  'questionModal.orderIdNotFound': '找不到订单ID。请重新加载订单详情。',
  'questionModal.failedToLoadOrderInfo': '无法加载订单信息。',
  'questionModal.messageRead': '已读',
  'questionModal.inventoryInquiry': '库存咨询',
  'questionModal.inventoryInquiryTitle': '库存咨询 - {orderNo}',
  'questionModal.stockProductInfo': '库存商品信息',
  'questionModal.stockColumns.stockNo': '库存号',
  'questionModal.stockColumns.center': '中心',
  'questionModal.stockColumns.productImage': '商品图片',
  'questionModal.stockColumns.mailbox': '信箱',
  'questionModal.stockColumns.memberName': '会员名',
  'questionModal.stockColumns.customsClearance': '通关物品',
  'questionModal.stockColumns.productName': '商品名称',
  'questionModal.stockColumns.trackingNo': '运单号',
  'questionModal.stockColumns.color': '颜色',
  'questionModal.stockColumns.size': '尺寸',
  'questionModal.stockColumns.quantityPrice': '数量*单价',
  'questionModal.stockColumns.total': '合计',
  'questionModal.stockColumns.rackNo': '货架号',
  'questionModal.stockColumns.previousRackNo': '原货架号',
  'questionModal.stockColumns.stockStatus': '库存状态',
  'questionModal.stockColumns.productStatus': '商品状态',
  'questionModal.stockColumns.registrationDate': '注册日期',
  'questionModal.stockColumns.modificationDate': '修改日期',
  'questionModal.edit': '编辑',
  'questionModal.delete': '删除',
  'questionModal.html': 'HTML',
  'questionModal.messagePlaceholder': '请输入消息...',
  'questionModal.htmlPlaceholder': '请输入HTML代码',
  'questionModal.sendButton': '发送',
  'questionModal.noMessagesYet': '还没有消息。请发送第一条消息。',
  'questionModal.inquiryNotCreatedYet': '咨询尚未创建。发送第一条消息时将创建咨询。',
  'questionModal.mock.deliveryAgent': '配送代理',
  'questionModal.mock.designatedDelivery': '指定配送',
  'questionModal.mock.weihai': '威海',
  'questionModal.mock.air': '航空',
  'questionModal.mock.receiver': '收件人',
  'questionModal.mock.warehouseComplete': '入库完成',
  'questionModal.mock.warehouseReceived': '已入库',
  'questionModal.mock.doorbell': '【门铃】',
  'questionModal.notAssignedResponder': '您不是此咨询的指定负责人。',
  'questionModal.translate': '翻译',
  'questionModal.showOriginal': '查看原文',
  'questionModal.translateFailed': '消息翻译失败。',
  'questionModal.translateEmpty': '没有可翻译的文本。',
  'questionModal.newMessages': '新消息',
  'questionModal.editingMessage': '编辑中',
};

